import {createReducer} from '@reduxjs/toolkit';
import {getPeriods, updatePeriod} from './actions';
import {PeriodDto} from '../../../dto/PeriodDto';

type InitialState = {
    [projectId: number]: PeriodDto[];
};

const initialState: InitialState = {};

export const periods = createReducer(initialState, (builder) =>
    builder
        .addCase(getPeriods.fulfilled, (state, action) => ({
            ...state,
            [action.meta.arg]: action.payload
        }))
        .addCase(updatePeriod.fulfilled, (state, action) => {
            const {projectId, periodId, locked} = action.payload;
            return {
                ...state,
                [projectId]: state[projectId]?.map((period) => (period.id === periodId ? {...period, locked} : period))
            };
        })
);
